import React, { PropsWithChildren, createContext, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export const SessionIdContext = createContext('');
export const ResetSessionIdContext = createContext(() => {
  return;
});

interface SessionIdContextProviderProps extends PropsWithChildren {
  sessionId: string;
  setSessionId(sessionId: string): void;
}
export const SessionIdContextProvider = ({
  sessionId,
  setSessionId,
  children,
}: SessionIdContextProviderProps) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.shareToPatientImageList',
  });

  const resetSessionId = useCallback(() => {
    alert(t('sessionExpired'));
    setSessionId('');
  }, [t, setSessionId]);

  return (
    <SessionIdContext.Provider value={sessionId}>
      <ResetSessionIdContext.Provider value={resetSessionId}>
        {children}
      </ResetSessionIdContext.Provider>
    </SessionIdContext.Provider>
  );
};
